module.exports = __webpack_public_path__ + "img/flli-logo-anim.62cba089.gif";